import React from "react";
import { Table } from "react-bootstrap";
import "./VehicleSpecificationsSection.css";
import { useTranslation } from "react-i18next";

export default function SpecificationTab({ category, variants }) {
  const { t } = useTranslation();

  if (!category || !variants?.length) return null;

  const leftHead = category?.leftHeadKey
    ? t(category.leftHeadKey)
    : t("vehicleSpecs.tableLeftHead");

  return (
    <div className="spec-tab">
      <div className="spec-table__wrap">
        <Table responsive bordered hover className="spec-table">
          <thead>
            <tr>
              <th className="spec-table__head-left">{leftHead}</th>

              {variants.map((v) => {
                const variantName = v.nameKey ? t(v.nameKey) : v.name;
                return (
                  <th key={v.id} className="spec-table__head">
                    {variantName}
                  </th>
                );
              })}
            </tr>
          </thead>

          <tbody>
            {(category.rows || []).map((row, idx) => {
              const rowLabel = row.labelKey ? t(row.labelKey) : row.label;

              return (
                <tr key={`${category.id}-${idx}`}>
                  <td className="spec-table__label">{rowLabel}</td>

                  {variants.map((v) => (
                    <td key={v.id} className="spec-table__value">
                      {row?.values?.[v.id] ?? t("common.dash")}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    </div>
  );
}